<template>            
    <div class="maslul_strip_list">
        <div class="item" v-for="item in items" :key="item.id">
            <router-link :to="item.link">
                <div class="pic" :style="'background-image:url(' + item.lecturers[0].pic_tumb + ')'"></div>
                <div class="details">
                    <h3>{{ item.title }}</h3>
                    <h4>{{ item.txt_hours }}</h4>
                </div>
                <div class="lecturer"><h5><strong v-text="item.lecturers[0].name"></strong> <span v-text="item.lecturers[0].job"></span></h5><div class="job_logo"><span :style="'background-image:url(' + item.lecturers[0].job_icon_tumb + ')'"></span></div></div>
            </router-link>
        </div>
    </div>
</template>

<script>

export default {
  props: ["items"],

  methods: {

    item_hover(id){
      //alert(4);
      this.$el.querySelector('#videopromo_' + id + ' video').play();
    }

  },
  created() {

  }
}
</script>